import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Layout/Sidebar";
import { fetchMenus } from "../Api/Auth";
import Header from "../Layout/Header";
interface Menu {
  menuId: number;
  menuName: string;
  displayText: string;
  routePath: string | null;
  componentKey: string;
  sortOrder: number;
  permissions: {
    canView: boolean;
    canAccess: boolean;
  };
  children: Menu[];
}
const HomeDashboard = () => {
const [menus, setMenus] = useState<Menu[]>([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const loadMenus = async () => {
      const data = await fetchMenus();
      setMenus(data?.menus || []);
    };
    loadMenus();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024; // Changed from 768 to 1024 to include tablets
      setIsMobile(mobile);
      if (mobile) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="h-screen flex flex-col bg-gray-50 overflow-hidden">
      {/* Header */}
      <div className="sticky top-0 z-50 bg-white shadow">
        <Header currentRole="creator" onToggleSidebar={toggleSidebar} />
      </div>

      {/* Main Content Area */}
      <div className="flex flex-1 overflow-hidden relative">
        {/* Sidebar - Fixed overlay on mobile/tablet, relative on desktop */}
        <aside
  className={`
    ${isMobile
      ? `
        fixed inset-y-0 left-0 z-40 mt-[45px]
        transition-transform duration-300
        ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
        w-64
      `
      : `
        relative transition-all duration-300
        ${isSidebarOpen ? "w-60" : "w-0"}
      `
    }
    bg-white shadow-lg border-r border-blue-200
    overflow-hidden
    h-full
  `}
>
  <Sidebar menus={menus} />
</aside>


        {/* Mobile/Tablet Overlay - Darkens background when sidebar is open */}
        {isMobile && isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-30 mt-[45px]"
            onClick={toggleSidebar}
          />
        )}

        {/* Main Content - Always visible, full width on mobile/tablet */}  
        <main 
          className={`
            flex-1 overflow-auto transition-all duration-300
            ${isMobile ? "w-full" : ""}
          `}
        >
          <div className="">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default HomeDashboard;
